export const cardTypes = Object.freeze({
    amex: 'American Express',
    diners: 'Diners',
    discover: 'Discover',
    mastercard: 'Mastercard',
    visa: 'Visa',
  })
